import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { makeTextReadable } from '~/helpers/color';
import Chip from '~/entities/chip';
import useCommandLaunch from '~/composables/useCommandLaunch';

export default function useDevice() {
  /**
   * i18n translator
   */
  const { t } = useI18n();

  const { lastCommandLaunch } = useCommandLaunch();
  /**
   * Get localized device type
   */
  function getLocalizedDeviceType(deviceType) {
    const keyMapping = {
      KeyNetic: 'device.type_KeyNetic',
      KeySmart: 'device.type_KeySmart',
      KeyVibe: 'device.type_KeyVibe',
    };

    return t(keyMapping[deviceType]);
  }

  /**
   * Check if device creation is allowed without a device
   */
  function isEventCreationPossibleWithoutDevice() {
    return parseInt(window.tenant.enable_create_deviceless_event, 10) === 1;
  }

  /**
   * Tells if the learning is disabled
   */
  const isDeviceLearningDisabled = computed(() => {
    const command = lastCommandLaunch.value;
    return command && (command.cl_device_command === '12' || command.cl_device_command === '13') && command.cl_state === 'WAITING';
  });

  /**
   * Returns devices name or type in the format of Chips
   *  - if device type is asked but that we dont find typeExpand we return device name
   * @param devices Provide an array of devices or a single one
   * @param displayType Display the device type code instead of the device name
   */
  function formatDeviceChipList(devices, displayType = false) {
    const chipBackgroundColor = 'color_b';
    const textColor = makeTextReadable(chipBackgroundColor, false);
    if (!Array.isArray(devices)) {
      return [new Chip({
        id: devices.id,
        title: displayType && devices.typeExpand?.code
          ? devices.typeExpand.code : devices.name,
        color: chipBackgroundColor,
        textColor,
        icon: 'info',
      })];
    }

    return devices.map((device) => (
      new Chip({
        id: device.id,
        title: displayType && device.typeExpand?.code ? device.typeExpand.code : device.name,
        color: chipBackgroundColor,
        textColor,
        icon: 'info',
      })
    ));
  }

  /**
   * Returns a color for the given device code
   */
  function getDeviceColor(deviceCode) {
    const deviceColorMap = {
      KeyNetic: 'white',
      KeySmart: 'color_g',
      KeyVibe: 'color_b',
    };
    return deviceColorMap[deviceCode] || '#000';
  }

  return {
    isDeviceLearningDisabled,
    formatDeviceChipList,
    getLocalizedDeviceType,
    isEventCreationPossibleWithoutDevice,
    getDeviceColor,
  };
}
